export var EXCLUDE_INTERNAL_REFERRERS_CONDITIONS = {
    always: 'always',
    ifEmptyCampaign: 'ifEmptyCampaign',
};
